import { PermissionClientSettings } from '../interfaces';
import { CONFIG_VERSION, CONFIG_TRACKING_ENABLED, CONFIG_TRACKING_SAMPLE_RATE } from '../../config';
import { getChanceResult } from '../../common/tools/util';

const SOFT_NAME = 'pppclient';

const BRAIN_DOMAINS: { [key: string]: string } = {
  '1und1': '1und1.de',
  '1und1de': '1und1.de',
  '1and1': '1and1.com',
  '1and1com': '1and1.com',
  'gmx': 'gmx.net',
  'gmxat': 'gmx.net',
  'gmxch': 'gmx.net',
  'gmxde': 'gmx.net',
  'gmxnet': 'gmx.net',
  'gmxcom': 'gmx.com',
  'gmxcouk': 'gmx.co.uk',
  'gmxes': 'gmx.es',
  'gmxfr': 'gmx.fr',
  'mailcom': 'mail.com',
  'webde': 'web.de',
};

function getBrainUrl(section: string, settings: PermissionClientSettings, type: string): string {
  const brandname = settings.portal === 'gmx' ? 'gmxde' : settings.portal;
  const brainDomain = BRAIN_DOMAINS[settings.portal];
  const brainSubdomain = settings.stage === 'live' ? 'wa' : 'wa-qa';

  return 'https://' + brainSubdomain + '.' + brainDomain + '/wa/t.gif?' +
    'soft_name=' + SOFT_NAME +
    '&soft_version=' + CONFIG_VERSION +
    '&brand=' + brandname +
    '&section=' + section +
    '&cont_requested_perm=' + (settings.forcePermissionLayer || settings.permissionGroup || '') +
    '&cont_touchpoint_id=' + (settings.touchpointName || '') +
    '&cont_touchpoint_ref=' + (settings.touchpointReference || '') +
    '&trackingtype=' + type +
    '&attributeset=2' +
    '&timestamp=' +  Date.now() +
    '&sett_sample=100';
}

/**
 * Simple BRAIN pixel generator for environments where we don't want to load TrackLib (e.g. publisher pages)
 * @param section tracking section name, e.g. 'permission.initial.start'
 * @param settings PPP settings
 * @param type tracking type, e.g. 'cl' for click. Default: 'ev' (event)
 */
export function trackBrain(section: string, settings: PermissionClientSettings, type= 'ev'): void {
  if (!CONFIG_TRACKING_ENABLED) {
    return;
  }

  const trackingActive = getChanceResult(CONFIG_TRACKING_SAMPLE_RATE || 1);
  if (!trackingActive) {
    return;
  }

  if (!section || typeof section !== 'string') {
    return;
  }
  try {
    new Image(1,1).src = getBrainUrl(section, settings, type);
    // eslint-disable-next-line no-empty
  } catch (ignore) {}
}
